import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { getLocaleCode } from "@/utils/get-locale-code";

const currencyTextV2Variants = cva("", {
  variants: {
    variant: {
      default: "",
      completeOrderDetails: "text-center text-lg font-medium",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

type CurrencyTextV2Props = VariantProps<typeof currencyTextV2Variants> & {
  currencyCode: string;
  price: string;
  className?: string;
  key?: string;
  translationKey?: string;
  currencyDisplay?: Intl.NumberFormatOptionsCurrencyDisplay;
};

export const CurrencyTextV2 = ({
  currencyCode,
  price,
  translationKey,
  currencyDisplay = "code",
  className,
  variant,
  ...props
}: CurrencyTextV2Props) => {
  const locale = translationKey ? getLocaleCode(translationKey) : "en";
  const priceNumber = Number(price);

  return (
    <span
      {...props}
      className={cn(currencyTextV2Variants({ variant }), className)}
    >
      {Intl.NumberFormat(locale, {
        currency: currencyCode,
        style: "currency",
        currencyDisplay,
        useGrouping: false,
        trailingZeroDisplay: "stripIfInteger",
      }).format(priceNumber)}
    </span>
  );
};
